import { Link } from 'react-router-dom';

interface CategoryNavProps {
  active: string;
}

const items = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'action', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'comedy', name: '喜剧片', icon: 'ri-emotion-happy-line' },
  { slug: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画片', icon: 'ri-bear-smile-line' },
  { slug: 'crime', name: '犯罪片', icon: 'ri-police-car-line' },
  { slug: 'war', name: '战争片', icon: 'ri-shield-flash-line' },
  { slug: 'fantasy', name: '奇幻片', icon: 'ri-magic-line' },
];

export default function CategoryNav({ active }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide py-2">
      {items.map((item) => (
        <Link
          key={item.slug}
          to={`/category/${item.slug}`}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 flex-shrink-0 ${
            active === item.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          <i className={`${item.icon} text-sm`}></i>
          {item.name}
        </Link>
      ))}
    </div>
  );
}